import { Trans } from '@lingui/react'
import {
  OfferDiscountTypeEnumV2,
  type SellerPromotionV2,
} from '@redteclab/api/clients/bully'

import {
  EXPERIMENT_VARIATION,
  MARKETPLACE_HARMONIZATION,
} from 'shared/experiments/consts'
import { useGetExperiment } from 'shared/experiments/utils/experiments'
import { type PublicRuntimeConfig } from 'types/shopConfig'
import Flag from 'views/components/atoms/Flag'
import IconCircleInfoOutline from 'views/components/atoms/Icon/IconCircleInfoOutline'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import { getLegalSupNote } from 'views/components/organisms/Cart/ProductListCart/SellerPromotionBanner/GetSellerPromotionNotification'
import { MARKETPLACE_DISCOUNT_MODAL_ID } from 'views/components/organisms/MarketPlaceDiscountModal/names'
import { OPEN_MARKETPLACE_DISCOUNT_MODAL } from 'views/containers/browser/MarketPlaceDiscountModalContainer/clientsideHook'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

const MarketplacePromotionBadge = ({
  sellerPromotion,
  publicRuntimeConfig: {
    publicConfig: { tenant },
  },
}: {
  sellerPromotion?: SellerPromotionV2
  publicRuntimeConfig: PublicRuntimeConfig
}) => {
  const marketplaceHarmonization = useGetExperiment(MARKETPLACE_HARMONIZATION)

  const isMarketplaceHarmonizationEnabled =
    marketplaceHarmonization.isEnabled &&
    marketplaceHarmonization.variant === EXPERIMENT_VARIATION.V1

  const marketPromotionFlag =
    sellerPromotion?.discountType === OfferDiscountTypeEnumV2.FreeItems ? (
      <Trans
        id="seller.promotion.sellerBanner.title.minimumSameItemQuantity.freeItems"
        values={{
          formattedConditionAmount: sellerPromotion.conditionValue,
          formattedDiscountAmount:
            sellerPromotion.conditionValue - sellerPromotion.discountValue,
          sup: <sup>{getLegalSupNote(tenant)}</sup>,
        }}
      />
    ) : (
      <Trans
        id="seller.promotion.sellerBanner.title.minimumSameItemQuantity.total"
        values={{
          sup: <sup>{getLegalSupNote(tenant)}</sup>,
        }}
      />
    )

  return (
    <div className="u-margin-x-small--bottom u-margin-x-small--top">
      <ButtonAsLink
        isClientsideControlled
        className="u-display--inline-block o-ProductInfo__labels"
        data-clientside-hook={OPEN_MARKETPLACE_DISCOUNT_MODAL}
        data-a11y-dialog-show={MARKETPLACE_DISCOUNT_MODAL_ID}
        data-discount-condition-value={sellerPromotion?.conditionValue}
        data-discount-value={sellerPromotion?.discountValue}
        data-discount-type={sellerPromotion?.discountType}
        type="button"
      >
        <Flag
          withIcon
          label={marketPromotionFlag}
          isMarketplaceHarmonizationEnabled={isMarketplaceHarmonizationEnabled}
        >
          <div className="u-padding-x-small--left l-flex">
            <IconCircleInfoOutline size="x-small" />
          </div>
        </Flag>
      </ButtonAsLink>
    </div>
  )
}

export default withShopAndRuntimeConfig(MarketplacePromotionBadge)
